import { weekdayJp } from "../types/public";
import { openXIntentCompose } from "./public-share-snippet";

export type NoticeShareFields = {
  event_name: string;
  event_date: string;
  venue: string | null;
  showTime: string | null;
  deadlineDate?: string | null;
  receptionEnd?: string | null;
  linkUrl: string | null;
  label?: string;
};

function formatJpLongDate(iso: string): string {
  const base = String(iso ?? "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(base)) return String(iso ?? "").trim() || "—";
  const [y, m, d] = base.split("-").map(Number);
  return `${y}年${m}月${d}日(${weekdayJp(base)})`;
}

/** 表サイトお知らせ：ワンタップコピー（宮本佳林の名前行なし） */
export function buildNoticeOneTapCopyText(n: NoticeShareFields): string {
  const title = String(n.event_name ?? "").trim() || "（イベント名未設定）";
  const lines: string[] = ["━━━━━━━━━━", title, ""];
  if (n.label) {
    lines.push(n.label);
    lines.push("");
  }
  lines.push("日程：");
  lines.push(formatJpLongDate(n.event_date));
  lines.push("");
  if (n.venue) {
    lines.push("会場：");
    lines.push(n.venue);
    lines.push("");
  }
  if (n.showTime) {
    lines.push("開演：");
    lines.push(n.showTime);
    lines.push("");
  }
  if (n.deadlineDate) {
    lines.push("締切：");
    lines.push(n.deadlineDate);
    lines.push("");
  }
  if (n.receptionEnd) {
    lines.push("受付終了：");
    lines.push(n.receptionEnd);
    lines.push("");
  }
  const url = String(n.linkUrl ?? "").trim();
  if (url) {
    lines.push("リンク：");
    lines.push(url);
    lines.push("");
  }
  lines.push("━━━━━━━━━━");
  return lines.join("\n");
}

export function buildNoticeOneTapXText(n: NoticeShareFields): string {
  const title = String(n.event_name ?? "").trim() || "（イベント名未設定）";
  const bits: string[] = ["━━━━━━━━━━", `${title}🫶`];
  if (n.label) bits.push(n.label);
  bits.push(`🗓${formatJpLongDate(n.event_date)}`);
  if (n.venue) bits.push(`📍${n.venue}`);
  if (n.showTime) bits.push(`⏰${n.showTime}`);
  const url = String(n.linkUrl ?? "").trim();
  if (url) {
    bits.push("");
    bits.push("詳細・申込みはこちら🫶");
    bits.push(url);
  }
  bits.push("", "━━━━━━━━━━");
  return bits.join("\n");
}

export { openXIntentCompose };
